<template>
  <div class="ti-detail-container">
    <div class="ti-detail ti-knowledge-container">
      <div class="question-section" v-for="(exercise, i) in list" :key="i">
        <div class="question-container">
          <div class="question-content" @click="onLooksExplain(exercise)">
            <div class="question-context">
              <div class="question-stem" v-html="exercise.context.stem"></div>
              <div class="question-options">
                <ul
                  v-if="exercise.context.options"
                  style="display: grid; grid-template-columns: auto auto;"
                >
                  <li
                    v-for="(options, index) in exercise.context.options"
                    :key="index"
                    v-html="optionHtml(index, options)"
                  ></li>
                </ul>
                <template >
                  <div
                    v-for="(explain, explain_index) in exercise.explain"
                    :key="explain_index"
                  >
                    <div class="question-answer" style="clear:both">
                      <div
                        class="ques-title ques-type"
                        :class="{
                          inlineBlock:
                            exercise.context.options ||
                            exercise.quesType.name == '判断题',
                        }"
                      >
                        【答案】
                      </div>
                      <div
                        v-for="(answers, answers_key) in explain.answers"
                        :key="answers_key"
                        class="question-answer-text"
                      >
                        <span
                          v-for="(answers_value, a_i_1) in answers"
                          :key="a_i_1"
                          v-html="answers_value"
                        ></span>
                      </div>
                    </div>
                    <div class="question-parsing">
                      <div class="ques-title ques-type">【解析】</div>
                      <div v-html="explain.analysis"></div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <template v-if="exercise.children">
              <div
                class="question-context"
                v-for="(children, childrenKey) in exercise.children"
                :key="childrenKey"
              >
                <div class="question-stem" v-html="children.context.stem"></div>
                <div class="question-options ">
                  <ul style="display: grid; grid-template-columns: auto auto;">
                    <li
                      v-for="(childrenOptions, childrenOptionsKey) in children
                        .context.options"
                      :key="childrenOptionsKey"
                      v-html="optionHtml(childrenOptionsKey, childrenOptions)"
                    ></li>
                  </ul>
                  <template >
                    <div
                      style="clear:both"
                      v-for="(childrenExplain,
                      childrenExplainKey) in children.explain"
                      :key="childrenExplainKey"
                    >
                      <div class="question-answer">
                        <div
                          class="ques-title ques-type"
                          :class="{
                            inlineBlock:
                              children.context.options ||
                              exercise.quesType.name == '判断题',
                          }"
                        >
                          【答案】
                        </div>
                        <div
                          v-for="(answer_v,
                          answer_i) in childrenExplain.answers"
                          :key="answer_i"
                          class="question-answer-text"
                        >
                          <span
                            v-for="(answer_v_1, answer_i_1) in answer_v"
                            :key="answer_i_1"
                            v-html="answer_v_1"
                          ></span>
                        </div>
                      </div>
                      <div class="question-parsing">
                        <div class="ques-title ques-type">【解析】</div>
                        <div v-html="childrenExplain.analysis"></div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
          <div
            class="ques-knowledge "
            style="clear:both"
          >
            <div class="ques-title ques-type">【考点】</div>
            <div class="knowledge-list">
              <span
                class="knowledge-text"
                v-for="(k_value, k_index) in exercise.knowledge"
                :key="k_index"
                >{{ k_value.name }}</span
              >
            </div>
          </div>
          <div class="  clearfix" style="clear:both">
            <div class="question-bottom flex-between">
              <div class="question-info">
                <span>更新：{{ exercise.updateTime | getLocalTime }}</span>
                <span>题型：{{ exercise.quesType.name }}</span>
                <span>难度：{{ exercise.difficulty.name }}</span>
                <span>组卷：{{ exercise.useCount }}</span>
              </div>
              <div class="question-operation">
                <!-- <div class="operation">
                  <i class="el-icon-tickets"></i>
                  <span class="operation-text">详情</span>
                </div>
                <div class="operation">
                  <i class="el-icon-edit-outline"></i>
                  <span class="operation-text">纠错</span>
                </div>
                <div class="operation">
                  <i class="el-icon-star-off"></i>
                  <span class="operation-text">收藏</span>
                </div> -->
                <el-button
                  type="danger"
                  icon="el-icon-minus"
                  size="mini"
                  round
                  @click="onRemoveQuestion(exercise)"
                  v-if="exercise.isAdd"
                  >试题篮</el-button
                >
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  size="mini"
                  round
                  @click="onAddQuestion(exercise)"
                  v-else
                  >试题篮</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <basket
      :stageCode="stageSubject.stage.code"
      :subjectCode="stageSubject.subject.code"
      :types="types"
      @deleteCallBack="onDeleteCallBack"
      ref="basketRef"
    ></basket>
  </div>
</template>
<script>
import Vue from "vue";
Vue.prototype.optionHtml = function(i, v) {
  // to do
  let html = ["A", "B", "C", "D"];
  return html[i] + "." + v;
};
import Basket from "../template/Basket.vue";
import { mapState } from "vuex";
export default {
  components: { Basket },
  data() {
    return {
      list: [],
      types: 0,
    };
  },
  computed: {
    ...mapState(["stageSubject"]),
  },
  created() {
    this.qid = this.$route.params.qid;
    this.types = parseInt(this.$route.params.types);
    this.getExercise();
  },
  filters: {
    getLocalTime: function(v) {
      return new Date(parseInt(v) * 1000).toLocaleString();
    },
  },
  methods: {
    getExercise() {
      let _url = "/wenjiaoopne/kc/basket/find";
      if (this.types === 1) {
        _url = "/wenjiaoopne/kc/basket/work/find";
      }
      this.postRequest(_url, {
        questionId: this.qid,
        stage: this.stageSubject.stage.code,
        subject: this.stageSubject.subject.code,
      })
        .then((result) => {
          this.list = result.data;
          console.log(this.list)
        })
        .catch(() => {});
    },
    onAddQuestion(item) {
      let _url = "/wenjiaoopne/kc/basket/add";
      if (this.types === 1) {
        _url = "/wenjiaoopne/kc/basket/work/add";
      }
      this.postRequest(_url, {
        questionId: item.questionId,
        stage: this.stageSubject.stage.code,
        subject: this.stageSubject.subject.code,
        subjective: item.subjective.code,
        typeName: item.quesType.name,
        types: item.quesType.code,
        source: 1,
      })
        .then(() => {
          this.$set(item, "isAdd", true);
          this.$refs.basketRef.getUserQuestion();
        })
        .catch(() => {});
    },
    onRemoveQuestion(item) {
      let _url = "/wenjiaoopne/kc/basket/remove";
      if (this.types === 1) {
        _url = "/wenjiaoopne/kc/basket/work/remove";
      }
      this.postRequest(_url, {
        questionId: item.questionId,
        stage: this.stageSubject.stage.code,
        subject: this.stageSubject.subject.code,
      })
        .then(() => {
          this.$set(item, "isAdd", false);
          this.$refs.basketRef.getUserQuestion();
        })
        .catch(() => {});
    },
    onDeleteCallBack() {

    },
  },
};
</script>
<style scoped>
@import "../../assets/css/question.css";
.ti-detail-container {
  background: #f1f1f1;
  padding: 15px 0;
}
.ti-detail {
  position: relative;
  width: 1195px;
  margin: 0 auto;
  padding: 10px 0;
  background-color: #fff;
}
</style>
